import React from 'react';
import './css/HelpfulInformation.styl';
import coping from './images/coping-btn-img.png';
import etiquette from './images/etiquette-btn-img.png';
import prePlanning from './images/pre-planning-btn-img.png';
import HelpfulInformationListItem from './HelpfulInformationListItem';
import appConfig from '../../../../../../appConfig/AppConfig';
import Header from '../../../../../shared/library/Header/Header';

const domain = appConfig().vanityDomain;

const HelpfulInformation = () => {
  const newsDomain = domain.replace(/https:/, 'http:');
  const helpfulInformation = [
    {
      header: 'How to Pay for a Funeral',
      title: 'coping',
      image: coping,
      path: `${newsDomain}/news/advice-and-support/article/how-to-pay-for-a-funeral`,
    },
    {
      header: 'Five Ways to Cover Funeral Costs in Advance',
      title: 'etiquette',
      image: etiquette,
      path: `${newsDomain}/news/advice-and-support/article/five-ways-to-cover-funeral-costs-in-advance`,
    },
    {
      header: 'What Funeral Benefits Am I Eligible For?',
      title: 'pre-planning',
      image: prePlanning,
      path: `${newsDomain}/news/advice-and-support/article/what-funeral-benefits-am-i-eligible-for`,
    },
  ];

  return (
    <div className="helpful-information-container">
      <Header
        type="aside-header"
        className="helpful-information-container__title"
        title="Helpful Information"
      />
      <ul>
        {helpfulInformation.map((infoItem, i) => (
          <HelpfulInformationListItem helpfulInformation={infoItem} key={i} />
        ))}
      </ul>
    </div>
  );
};

export default HelpfulInformation;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Shared/HelpfulInformation/index.js